import { useState } from "react";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

export const WeekBreakdown = ({ weeks, eyebrow, title, subtitle, mentor, theme, testPrefix = "", bg = "bg-dream-bg" }) => {
  const [active, setActive] = useState(0);
  const Current = weeks[active].icon;
  const cols = weeks.length > 4 ? "grid-cols-2 lg:grid-cols-4" : "lg:grid-cols-4";

  return (
    <section className={`py-24 ${bg}`} data-testid={`${testPrefix}week-breakdown`}>
      <div className="max-w-7xl mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-16">
          <p className={`${theme.text} font-mono text-sm tracking-widest mb-4 uppercase`}>{eyebrow}</p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">{title}</h2>
          <p className="text-white/60 max-w-xl mx-auto">{subtitle}</p>
        </motion.div>

        <div className={`grid ${cols} gap-4 mb-8`}>
          {weeks.map((week, index) => {
            const WIcon = week.icon;
            const on = active === index;
            return (
              <button
                key={week.week}
                onClick={() => setActive(index)}
                className={`p-6 rounded-2xl text-left transition-colors border ${on ? theme.activeTab : `bg-white/[0.03] border-white/10 ${theme.hoverBorder}`}`}
                data-testid={`${testPrefix}week-tab-${week.week}`}
              >
                <WIcon className={`w-6 h-6 mb-3 ${on ? "text-white" : theme.text}`} />
                <p className={`text-xs font-mono mb-2 ${on ? "text-white/80" : theme.text}`}>Week {week.week}</p>
                <h3 className="font-heading font-bold text-white text-base leading-tight">{week.title}</h3>
              </button>
            );
          })}
        </div>

        <motion.div key={active} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="glass rounded-2xl p-8" data-testid={`${testPrefix}week-detail`}>
          <div className="flex items-center gap-4 mb-4">
            <div className={`w-12 h-12 rounded-xl ${theme.iconBg} flex items-center justify-center`}>
              <Current className={`w-6 h-6 ${theme.text}`} />
            </div>
            <div>
              <p className={`${theme.text} text-sm font-mono uppercase tracking-wider`}>Week {weeks[active].week}</p>
              <h3 className="font-heading text-2xl font-bold text-white">{weeks[active].title}</h3>
            </div>
          </div>
          <p className="text-white/50 mb-6">2 hours of focused, hands-on training with {mentor}</p>
          <div className="grid sm:grid-cols-2 gap-3">
            {weeks[active].topics.map((topic) => (
              <div key={topic} className="flex items-center gap-3 bg-dream-bg/50 rounded-xl p-4 border border-white/5">
                <div className={`w-8 h-8 ${theme.iconBg} rounded-lg flex items-center justify-center flex-shrink-0`}>
                  <CheckCircle2 className={`w-4 h-4 ${theme.text}`} />
                </div>
                <span className="text-white/85">{topic}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
